import type { BalanceConfig, EnemyConfig, MapConfig } from "@bastion/data";

export interface ScaledEnemyStats {
  maxHp: number;
  attack: number;
  magic: number;
  defense: number;
  magicResistance: number;
  speed: number;
}

export function scaleEnemyStats(
  enemy: EnemyConfig,
  map: MapConfig,
  balance: BalanceConfig,
  waveIndex: number,
): ScaledEnemyStats {
  const growthFactor = map.isEndless
    ? 1 + (waveIndex / 5) * 0.4
    : 1 + map.enemyStatGrowthPerWave * waveIndex;
  return {
    maxHp: enemy.stats.maxHp * growthFactor * (balance.globalEnemyHpMultiplier ?? 1),
    attack: enemy.stats.attack * growthFactor,
    magic: enemy.stats.magic * growthFactor,
    defense: enemy.stats.defense * growthFactor,
    magicResistance: enemy.stats.magicResistance * growthFactor,
    speed: enemy.stats.speed * (balance.globalEnemySpeedMultiplier ?? 1),
  };
}
